<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Edit'}}{{(type)? ' ' + type: ''}}</strong>
        </div>
        <div class="col-md-1">
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
  <div class="card-body">
  <div class>
    <div class="mb5"></div>
    <!-- <vform :formData="editForm" :fields="fields" :submitCallback="showSmallModal"/> -->
    <form @onsubmit.prevent action>
      <div class="row">
        <div v-for="field in fields" class="form-group col-md-2 col-sm-6 col-xs-6" v-bind:key="field.name">
            <label :for="field.name" class="form-control-label">{{getLabel(field.label)}}</label>
            <div v-if="field.type == 'inline-checkbox'" class="form-check">
              <div v-for="option in field.options" class="checkbox" v-bind:key="option.label">
                <label for="checkbox1" class="form-check-label">
                  <input
                    v-model="formData[field.name]"
                    type="checkbox"
                    :value="option.value"
                    :name="field.name"
                    class="form-check-input"
                  >
                  {{option.label}}
                </label>
              </div>
            </div>
            <div v-else-if="field.type == 'inline-radio'" class="form-check-inline form-check">
              <label
                v-for="option in field.options"
                class="form-check-label"
                style="padding:0px 10px;"
                v-bind:key="option.label"
              >
                <input
                  v-model="formData[field.name]"
                  type="radio"
                  :name="field.name"
                  class="form-check-input"
                  :value="option.value"
                >
                {{option.label}}
              </label>
            </div>
            <input
              v-else
              type="field.type"
              v-model="formData[field.name]"
              id="field.name"
              :placeholder="field.placeholder"
              class="form-control"
            >
            <small v-if="errors[field.name]" class="form-text text-danger">{{errors[field.name]}}</small>
            <small v-else-if="field.help" class="form-text text-muted">This is a help text</small>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group pull-right">
            <button @click="saveMacroData" type="button" class="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    </form>
    <PinCheck
      :show.sync="show"
      ref="smallModal"
      v-bind:small="true"
      @submitForm="submitForm"
      :cancelClass="'btn btn-secondary'"
    ></PinCheck>
  </div>
  </div>
  </div>
</template>
<script>
// import vform from "@/components/vform";
import { commonMixins } from "../../assets/mixins/common.js";
import http from "@/lib/http";
import PinCheck from "@/components/PinCheck.vue";
export default {
  name: 'DebtRating',
  components: { PinCheck },
  mixins: [commonMixins],
  created() {
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.getRawData();
    } else {
      this.$router.go(-1);
    }
  },
  data() {
    return {
      show: false,
      fields: [],
      formData: {},
      errors: [],
      rawData: [],
      type: 'qualitativeStatements'
    };
  },
  methods: {
    submitEditForm: function() {
      let myself = this;
      console.log("submit form", this.formData);
      http.put(
        "mutual-funds/form?name="+myself.type,
        this.formData,
        (error, response) => {
          console.log(response);
          if(response.message == 'success') {
            this.$toastr.success("Updated Successfully!", "", {});
          } else {
            this.$toastr.error("Oops, Something went wrong!", "", {});
          }
        }
      );
    },
    setData() {
      var fields = Object.keys(this.rawData);
      fields.forEach((val, key) => {
        this.fields.push(        
          {
            label: val,
            name: val,
            type: "number",
            value: this.rawData[val]
          }
        );
      });
      console.log(this.fields);
    },
    setFormData() {
      for (var index in this.fields) {
        let field = this.fields[index];
        if (!field.placeholder) field.placeholder = "";
        if (!field.help) field.help = "";
        this.formData[field.name] = this.rawData[field.name];
        this.$set(this.formData, field.name, field.value);
      }
      console.log("this.formData", this.formData);
    },
    getFixed(num) {
      let n = parseFloat(num).toFixed(2);
      return n != "NaN" ? n : "-";
    },
    cancel(d) {
      console.log("Cancel =>", d);
    },
    submitForm() {
      console.log("submitpin entered");
      // this.validatePin(pin);
      this.submitEditForm();
    },
    showSmallModal() {
      this.$refs.smallModal.open();
    },
    saveMacroData() {
      // this.submitForm();
      // this.formData["update"] = 0;
      this.$refs.smallModal.open();
    },
    updateMacroData() {
      // this.formData["update"] = 1;
      // this.$refs.smallModal.open();
    },
    getRawData() {
      http.get(
        "mutual-funds/form?name="+this.type,
        {},
        (error, response) => {
          if (response.message === 'success') {
            this.rawData = response.data;
            this.setData();
            this.setFormData();
          }
        }
      );
    }
  },
  watch: {
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/debt-ratings.vue